import { useState } from "react";
import PropTypes from "prop-types";
import { Button, Form } from "react-bootstrap";
import classNames from "classnames";
import { useNavigate, useSearchParams } from "react-router-dom";

import { resetPasswordHandler } from "../../utils/firebase";

const ResetPasswordForm = ({ hasLabel }) => {
	// State
	const [formData, setFormData] = useState({
		password: "",
		confirmPassword: "",
	});
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	// Handler
	const handleSubmit = async (e) => {
		e.preventDefault();
		await resetPasswordHandler(
			searchParams.get("oobCode"),
			formData.password,
			navigate,
		);
		setFormData({ password: "", confirmPassword: "" });
	};

	const handleFieldChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	return (
		<Form
			className={classNames("mt-3", { "text-left": hasLabel })}
			onSubmit={(e) => handleSubmit(e)}>
			<Form.Group className="mb-3">
				{hasLabel && <Form.Label>New Password</Form.Label>}
				<Form.Control
					placeholder={!hasLabel ? "New Password" : ""}
					value={formData.password}
					name="password"
					onChange={handleFieldChange}
					type="password"
					size="md"
				/>
			</Form.Group>

			<Form.Group className="mb-3">
				{hasLabel && <Form.Label>Confirm Password</Form.Label>}
				<Form.Control
					placeholder={!hasLabel ? "Confirm Password" : ""}
					value={formData.confirmPassword}
					name="confirmPassword"
					onChange={handleFieldChange}
					type="password"
					size="md"
				/>
			</Form.Group>

			<Button
				type="submit"
				className="w-100"
				disabled={
					!formData.password ||
					!formData.confirmPassword ||
					formData.password !== formData.confirmPassword
				}
				// onClick={(e) => handleSubmit(e)}
			>
				Set password
			</Button>
		</Form>
	);
};

ResetPasswordForm.propTypes = {
	hasLabel: PropTypes.bool,
};

export default ResetPasswordForm;
